<template>
    <div class="rounded-xl text-[#000] p-2 text-lg my-2 w-full box-border" :class="[computedClasses]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'warning'
        },
        align: {
            type: String,
            default: 'center'
        }
    },
    computed: {
        computedClasses() {
            return {
                'text-left': this.align === 'left',
                'text-center': this.align === 'center',
                'text-right': this.align === 'right',
                'bg-light-warning': this.type === 'warning',
                'bg-danger': this.type === 'error',
                'bg-primary': this.type === 'primary',
                'bg-secondary': this.type === 'secondary'
            };
        }
    }
}
</script>

<style scoped>

</style>
